import {normalizeMaterialAnnotations} from './materialAnnotationModel';

export const MATERIAL_ANNOTATION_STORAGE_PREFIX='STORAGE_MATERIAL_JSON:';
const bytes=value=>new Blob([JSON.stringify(value)]).size;
const validId=value=>typeof value==='string' && value.length>0 && value.length<=180 && !value.includes('/') && !value.includes('\\') && ![...value].some(character=>character.charCodeAt(0)<32) && value!=='.' && value!=='..';
const revisionId=()=>(typeof window!=='undefined' && window.crypto?.randomUUID?.()) || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
const uploadedValues=new WeakMap();

// Save immutable objects. If the later Firestore write fails, its old pointer
// still resolves to the previous complete annotation set, not a partial overwrite.
export function materialAnnotationStoragePath({userId,lectureId},revision=revisionId()) {
    if(!validId(userId) || !validId(lectureId) || !/^[\w-]{1,120}$/.test(revision))throw new Error('The material annotation save location is invalid.');
    return `lectureNotes/${userId}/${encodeURIComponent(lectureId)}_material_${revision}.json`;
}
export async function prepareMaterialAnnotationsForSave(draft,upload) {
    const materialAnnotations=normalizeMaterialAnnotations(draft.materialAnnotations);
    const packedDraft={...draft,materialAnnotations};
    if(Object.keys(materialAnnotations.sources).length===0)return materialAnnotations;
    if(bytes(materialAnnotations)<350000 && bytes(packedDraft)<750000)return materialAnnotations;
    const json=JSON.stringify(materialAnnotations);
    const scope=JSON.stringify([draft.userId,draft.lectureId]),cached=uploadedValues.get(draft.materialAnnotations);
    if(cached?.scope===scope && cached.json===json)return cached.pointer;
    const url=await upload(json,{path:materialAnnotationStoragePath(draft),contentType:'application/json',cacheControl:'no-store'});
    if(typeof url!=='string' || !/^https?:\/\//i.test(url))throw new Error('The material annotation upload did not return a valid saved file.');
    const pointer=MATERIAL_ANNOTATION_STORAGE_PREFIX+url;
    uploadedValues.set(draft.materialAnnotations,{scope,json,pointer});
    return pointer;
}
export async function resolveMaterialAnnotations(value,options={}) {
    if(typeof value==='string'){
        if(!value.startsWith(MATERIAL_ANNOTATION_STORAGE_PREFIX))throw new Error('The saved material annotation reference is invalid.');
        const url=value.slice(MATERIAL_ANNOTATION_STORAGE_PREFIX.length);
        if(!/^https?:\/\//i.test(url))throw new Error('The saved material annotation reference is invalid.');
        const request={cache:'no-store'};
        if(options.signal)request.signal=options.signal;
        const response=await (options.fetcher || fetch)(url,request);
        if(!response.ok)throw new Error('The saved material annotations could not be downloaded.');
        value=await response.json();
        if(!value || value.version!==1 || !value.sources)throw new Error('The saved material annotation file is invalid.');
    }
    return normalizeMaterialAnnotations(value);
}
